module.exports = __webpack_public_path__ + "clickup-5-ae896c17d188e1932dc47f46ac03f141.webp";